<script setup>
import { useI18n } from 'vue-i18n';
import LaisCheckbox from 'dashboard/components-next/checkbox/Checkbox.vue';

const props = defineProps({
  row: { type: Object, required: true },
  saving: { type: Boolean, default: false },
});
const emit = defineEmits(['toggleQueue']);
const { t } = useI18n();

const toggle = (type, value) =>
  emit('toggleQueue', { userId: props.row.id, type, value });
</script>

<template>
  <tr>
    <td class="px-4 py-3 font-medium text-lais-text">
      {{ row.responsavel }}
    </td>
    <td class="px-4 py-3 text-center font-semibold">{{ row.total }}</td>
    <td class="px-4 py-3 text-center">{{ row.a_vista }}</td>
    <td class="px-4 py-3 text-center">{{ row.financiado }}</td>
    <td class="px-4 py-3 text-center">{{ row.fgts }}</td>
    <td class="px-4 py-3 text-center">{{ row.consorcio }}</td>
    <td class="px-4 py-3 text-center text-emerald-700">{{ row.em_dia }}</td>
    <td class="px-4 py-3 text-center text-amber-700">{{ row.alerta }}</td>
    <td class="px-4 py-3 text-center text-red-700">{{ row.atrasado }}</td>
    <td class="px-4 py-3 text-center">
      <label
        :aria-label="
          t('POST_SALE.MANAGEMENT.QUEUE_TOGGLE_CASH', {
            name: row.responsavel,
          })
        "
      >
        <LaisCheckbox
          :model-value="row.check_a_vista"
          :disabled="saving"
          @update:model-value="toggle('a_vista', $event)"
        />
      </label>
    </td>
    <td class="px-4 py-3 text-center">
      <label
        :aria-label="
          t('POST_SALE.MANAGEMENT.QUEUE_TOGGLE_FINANCING', {
            name: row.responsavel,
          })
        "
      >
        <LaisCheckbox
          :model-value="row.check_financiado"
          :disabled="saving"
          @update:model-value="toggle('financiado', $event)"
        />
      </label>
    </td>
  </tr>
</template>
